(function () {
  function applyVariant(el, variant) {
    if (!el || !variant) return;

    var base = el.dataset.baseTitle || '';
    var typeKey = el.dataset.typeOptionKey;
    var colorKey = el.dataset.colorOptionKey;
    var suffix = '';

    if (typeKey && variant[typeKey]) suffix += ' ' + variant[typeKey].toLowerCase();
    if (colorKey && variant[colorKey]) suffix += ' ' + variant[colorKey].toLowerCase();

    el.textContent = base + suffix;
  }

  if (typeof subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) return;

  subscribe(theme.PUB_SUB_EVENTS.variantChange, function (event) {
    var sectionId = event.data.sectionId;
    var variant = event.data.variant;
    if (!sectionId || !variant) return;

    document
      .querySelectorAll('[data-product-title-variant][data-section-id="' + sectionId + '"]')
      .forEach(function (el) {
        applyVariant(el, variant);
      });
  });
})();
